module.exports = __webpack_public_path__ + "static/media/luke-chesser.99e9b386.jpg";